/**
 * File: apps/qbench-cp/reactapp/src/shared/hooks/misc/usePermissionCheck.js
 *
 * Purpose: Checks whether a given permission key is granted in the current app-level
 *     permissions state.
 *
 * Scope: feature and module permission gating throughout the customer portal.
 *
 * Tags: customer-portal, portal-roles
 *
 * Overview: Reads the permissions map from the app store. Returns true when no permission key
 *     is required, the permission's boolean value when the key is present in permissions, and
 *     false otherwise.
 *
 * Exports: default usePermissionCheck hook.
 */

import { isNil } from 'lodash';
import { useAppStore } from 'App/store';

export default function usePermissionCheck(requiredPermission) {
  const {
    appState: { permissions },
  } = useAppStore();
  let isSufficient = false;

  if (isNil(requiredPermission)) {
    isSufficient = true;
  } else if (requiredPermission in permissions) {
    isSufficient = permissions[requiredPermission];
  }
  return isSufficient;
}
